var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartHealth = function SvgHeartHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.172 6.09h2.988c1.367 0 1.555 2.14 0 2.272h-3.136c.701.332 2.798 2.013 2.798 4.404 0 2.988-2.65 9.03-6.321 9.03-2.987 0-6.12-5.192-6.12-9.03m9.79-6.675c-.796.575-1.792 1.903-.995 3.762m.996-3.762c.421-.305 1.125-.777 1.435-1.176.949-1.224-.802-2.638-2.298-1.545-.678.495-2.179 1.472-2.337 3.067m0 0c-.38-1.605-1.825-2.615-2.364-3.067-.778-.652-2.436-.473-2.356.91s1.727 1.3 1.727 2.743c0 .757-3.597.653-3.597 5.743m6.59-6.33c.38 1.606.534 4.11-6.59 6.33m6.119-.53c.414.173.762.877.553 1.558m-2.404 3.23c.714-.455 1.036-.921 1.364-1.315m1.04-1.915c1.409-1.028 3.118-.325 3.118.898m-3.118-.898c-.172.558-.388 1.13-1.04 1.915m0 0c1.796 0 3.295 2.067.958 3.29"
  })));
};
export default SvgHeartHealth;